export default {
  data() {
    return {
      // filter
      isFilterModalOpen: false,
      filterFields: {
        fromDate: '',
        toDate: '',
      },
      //row 1
      dashboardQCOnlineUser: '',
      dashboardQCMissionCount: null,
      dashboardQCActiveCode: null,
      dashboardQC107Code: null,
      //row 2
      //survey
      dashboardQCPieSurveyChartOptions: {
        colors: [
          '#80475E',
          '#6290C8',
          '#91C4DD',
          '#FFA7D9',
          '#9C914F',
          '#64E7EA',
          '#7681B3',
          '#596157',
          '#A49391',
          '#4A898C',
          '#DDDBCB',
          '#E07BE0',
        ],
        chart: {
          renderTo: 'dashboardQCPieSurveynChart',
          type: 'pie',
          height: '240px',
          redraw: true,
        },
        title: {
          text: '',
        },
        legend: {
          layout: 'vertical',
          useHTML: true,
          enabled: false,
          rtl: true,
          align: 'right',
          verticalAlign: 'middle',
          itemMarginTop: 3,
          itemMarginBottom: 3,
          itemStyle: {
            fontSize: '10px',
            direction: 'ltr',
            textAlign: 'left',
            width: '80px',
          },
        },
        series: [
          {
            name: '',
            keys: ['name', 'y', 'tooltipText'],
            colorByPoint: true,
            data: [],
            size: '100%',
            slicedOffset: 5,
            showInLegend: true,
            useHTML: true,
          },
        ],
        plotOptions: {
          pie: {
            innerSize: 0,
            depth: 0,
            dataLabels: {
              enabled: true,
              useHTML: true,
              style: {
                fontSize: '9px',
                textOutline: 'none',
                color: '#ffffff',
              },
            },
          },
          useHTML: true,
          series: {
            title: 'تماس',
            cursor: 'pointer',
            borderRadius: 5,
            dataLabels: [
              {
                enabled: true,
                distance: 15,
                format: '{point.name}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
              {
                enabled: true,
                distance: '-20%',
                format: '{point.y}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
            ],
          },
        },
        tooltip: {
          useHTML: true,
          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{point.tooltipText}</span>: <span  style="color:white">{point.y}</span></div><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">درصد</span>: <span  style="color:white">{point.percentage:.2f}</span></div>',
        },
      },
      //pie rank
      dashboardQCPieRankChartOptions: {
        colors: [],
        chart: {
          renderTo: 'dashboardQCPieRankChart',
          type: 'pie',
          height: '240px',
          redraw: true,
        },
        title: {
          text: '',
        },
        legend: {
          layout: 'vertical',
          useHTML: true,
          enabled: false,
          rtl: true,
          align: 'right',
          verticalAlign: 'middle',
          itemMarginTop: 3,
          itemMarginBottom: 3,
          itemStyle: {
            fontSize: '10px',
            direction: 'ltr',
            textAlign: 'left',
            width: '80px',
          },
        },
        series: [
          {
            name: '',
            keys: ['name', 'y', 'tooltipText'],
            colorByPoint: true,
            data: [],
            size: '100%',
            slicedOffset: 5,
            showInLegend: true,
            useHTML: true,
          },
        ],
        plotOptions: {
          pie: {
            innerSize: 90,
            depth: 50,
            dataLabels: {
              enabled: true,
              useHTML: true,
              style: {
                fontSize: '9px',
                textOutline: 'none',
                color: '#ffffff',
              },
            },
          },
          useHTML: true,
          series: {
            title: 'اولویت ها',
            cursor: 'pointer',
            borderRadius: 5,
            dataLabels: [
              {
                enabled: true,
                distance: 15,
                format: '{point.name}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
              {
                enabled: true,
                distance: '-20%',
                format: '{point.y}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
            ],
          },
        },
        tooltip: {
          useHTML: true,
          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{point.tooltipText}</span>: <span  style="color:white">{point.y}</span></div><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">درصد</span>: <span  style="color:white">{point.percentage:.2f}</span></div>',
        },
      },
      //pie call
      dashboardQCPieCallChartOptions: {
        colors: [
          '#80475E',
          '#6290C8',
          '#91C4DD',
          '#FFA7D9',
          '#9C914F',
          '#64E7EA',
          '#7681B3',
          '#596157',
          '#A49391',
          '#4A898C',
          '#DDDBCB',
          '#E07BE0',
        ],
        chart: {
          renderTo: 'dashboardQCPieCallChart',
          type: 'pie',
          height: '240px',
          redraw: true,
        },
        title: {
          text: '',
        },
        legend: {
          layout: 'vertical',
          useHTML: true,
          enabled: false,
          rtl: true,
          align: 'right',
          verticalAlign: 'middle',
          itemMarginTop: 3,
          itemMarginBottom: 3,
          itemStyle: {
            fontSize: '10px',
            direction: 'ltr',
            textAlign: 'left',
            width: '80px',
          },
        },
        series: [
          {
            name: '',
            keys: ['name', 'y', 'tooltipText'],
            colorByPoint: true,
            data: [],
            size: '100%',
            slicedOffset: 5,
            showInLegend: true,
            useHTML: true,
          },
        ],
        plotOptions: {
          pie: {
            innerSize: 0,
            depth: 0,
            dataLabels: {
              enabled: true,
              useHTML: true,
              style: {
                fontSize: '9px',
                textOutline: 'none',
                color: '#ffffff',
              },
            },
          },
          useHTML: true,
          series: {
            title: 'تماس',
            cursor: 'pointer',
            borderRadius: 5,
            dataLabels: [
              {
                enabled: true,
                distance: 15,
                format: '{point.name}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
              {
                enabled: true,
                distance: '-20%',
                format: '{point.y}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
            ],
          },
        },
        tooltip: {
          useHTML: true,
          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{point.tooltipText}</span>: <span  style="color:white">{point.y}</span></div><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">درصد</span>: <span  style="color:white">{point.percentage:.2f}</span></div>',
        },
      },
      //row 3
      dashboardQCCallToSend: null,
      dashboardQCCallToArrive: null,
      dashboardQCCallToArriveFence: null,
      dashboardQCSendToArrive: null,
      dashboardQCSendToArriveFence: null,
      dashboardQCGetToMove: null,
      dashboardQCGetToMoveFence: null,
      //row3 - 2
      dashboardQCMoveToArrive: null,
      dashboardQCMoveToArriveFence: null,
      dashboardQCStayPatient: null,
      dashboardQCStayPatientFence: null,
      dashboardQCStayHospital: null,
      dashboardQCStayHospitalFence: null,
      dashboardQCCallToFinish: null,
      dashboardQCCallToFinishFence: null,
      //row 4
      //line mission chart
      dashboardQCLineMissionChartOptions: {
        chart: {
          type: 'spline',
          height: '240px',
          zoomType: 'x',
          resetZoomButton: {
            position: {
              verticalAlign: 'top',
              align: 'left',
            },
          },
        },
        title: {
          text: '',
        },
        subtitle: {
          text: '',
        },
        xAxis: {
          type: 'datetime',
        },
        legend: {
          enabled: false,
        },
        yAxis: {
          title: {
            text: '',
          },
          labels: {
            format: '{value}',
          },
        },
        tooltip: {
          useHTML: true,
          crosshairs: true,
          shared: true,
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: '#666666',
              lineWidth: 1,
            },
          },
        },
        series: [
          {
            name: 'ماموریت ها',
            marker: {
              symbol: 'diamond',
            },
            data: [],
          },
        ],
      },
    };
  },
  methods: {
    openFilterModal: function () {
      this.isFilterModalOpen = true;
    },
    closeFilterModal: function () {
      this.isFilterModalOpen = false;
    },
    readyQCDashboard: function (data) {
      this.dashboardQCOnlineUser = data.onlineUsers.valueLong;
      this.dashboardQCMissionCount = data.missions.valueLong;
      this.dashboardQCActiveCode = data.activePhones.valueLong;
      this.dashboardQC107Code = data.outOfServicePhones.valueLong;
      //row2
      //pie survey chart
      let pieChartData3 = JSON.parse(JSON.stringify([]));
      let pieChartTempArray3 = JSON.parse(JSON.stringify([]));
      pieChartTempArray3 = JSON.parse(JSON.stringify(data.surveys));
      for (let i = 0; i < pieChartTempArray3.length; i++) {
        pieChartData3.push({
          name: pieChartTempArray3[i].title,
          y: pieChartTempArray3[i].valueLong,
          tooltipText: 'تعداد',
        });
      }
      pieChartData3 = JSON.parse(JSON.stringify(pieChartData3));
      this.dashboardQCPieSurveyChartOptions.series[0].data = [];
      this.dashboardQCPieSurveyChartOptions.series[0].data = pieChartData3;
      //pie rank chart
      let pieChartData = JSON.parse(JSON.stringify([]));
      let pieChartTempArray = JSON.parse(JSON.stringify([]));
      pieChartTempArray = JSON.parse(JSON.stringify(data.missionsByRank));
      for (let i = 0; i < pieChartTempArray.length; i++) {
        if (
          pieChartTempArray[i].title == 'سفید' &&
          !this.dashboardQCPieRankChartOptions.colors.includes('#EBEBEB')
        ) {
          this.dashboardQCPieRankChartOptions.colors.push('#EBEBEB');
        } else if (
          pieChartTempArray[i].title == 'سبز' &&
          !this.dashboardQCPieRankChartOptions.colors.includes('#2EBA7F')
        ) {
          this.dashboardQCPieRankChartOptions.colors.push('#2EBA7F');
        } else if (
          pieChartTempArray[i].title == 'زرد' &&
          !this.dashboardQCPieRankChartOptions.colors.includes('#FFBD55')
        ) {
          this.dashboardQCPieRankChartOptions.colors.push('#FFBD55');
        } else if (
          pieChartTempArray[i].title == 'قرمز' &&
          !this.dashboardQCPieRankChartOptions.colors.includes('#DA6757')
        ) {
          this.dashboardQCPieRankChartOptions.colors.push('#DA6757');
        }
        pieChartData.push({
          name: pieChartTempArray[i].title,
          y: pieChartTempArray[i].valueLong,
          tooltipText: 'تعداد',
        });
      }
      pieChartData = JSON.parse(JSON.stringify(pieChartData));
      this.dashboardQCPieRankChartOptions.series[0].data = [];
      this.dashboardQCPieRankChartOptions.series[0].data = pieChartData;
      //pie Call
      let pieChartData2 = JSON.parse(JSON.stringify([]));
      let pieChartTempArray2 = JSON.parse(JSON.stringify([]));
      pieChartTempArray2 = JSON.parse(JSON.stringify(data.calls));
      for (let i = 0; i < pieChartTempArray2.length; i++) {
        pieChartData2.push({
          name: pieChartTempArray2[i].title,
          y: pieChartTempArray2[i].valueLong,
          tooltipText: 'تعداد',
        });
      }
      pieChartData2 = JSON.parse(JSON.stringify(pieChartData2));
      this.dashboardQCPieCallChartOptions.series[0].data = [];
      this.dashboardQCPieCallChartOptions.series[0].data = pieChartData2;
      //rows 3
      let duration1 = Math.round(data.callTillDispatchAvg.valueDouble);
      duration1 = duration1 * 1000;
      this.dashboardQCCallToSend = this.msToTime(duration1);

      let duration2 = Math.round(data.callTillArriveAvg.valueDouble);
      duration2 = duration2 * 1000;
      this.dashboardQCCallToArrive = this.msToTime(duration2);

      let duration3 = Math.round(data.callTillArriveFenceAvg.valueDouble);
      duration3 = duration3 * 1000;
      this.dashboardQCCallToArriveFence = this.msToTime(duration3);

      let duration4 = Math.round(data.dispatchTillArriveDurationAvg.valueDouble);
      duration4 = duration4 * 1000;
      this.dashboardQCSendToArrive = this.msToTime(duration4);

      let duration5 = Math.round(data.dispatchTillArriveDurationFenceAvg.valueDouble);
      duration5 = duration5 * 1000;
      this.dashboardQCSendToArriveFence = this.msToTime(duration5);

      let duration6 = Math.round(data.deliveryTillMoveAvg.valueDouble);
      duration6 = duration6 * 1000;
      this.dashboardQCGetToMove = this.msToTime(duration6);

      let duration7 = Math.round(data.deliveryTillMoveFenceAvg.valueDouble);
      duration7 = duration7 * 1000;
      this.dashboardQCGetToMoveFence = this.msToTime(duration7);
      //row 3 - 2
      let duration8 = Math.round(data.moveTillArriveAvg.valueDouble);
      duration8 = duration8 * 1000;
      this.dashboardQCMoveToArrive = this.msToTime(duration8);

      let duration9 = Math.round(data.moveTillArriveFenceAvg.valueDouble);
      duration9 = duration9 * 1000;
      this.dashboardQCMoveToArriveFence = this.msToTime(duration9);

      let duration10 = Math.round(data.patientWaitingDurationAvg.valueDouble);
      duration10 = duration10 * 1000;
      this.dashboardQCStayPatient = this.msToTime(duration10);

      let duration11 = Math.round(data.patientWaitingDurationFenceAvg.valueDouble);
      duration11 = duration11 * 1000;
      this.dashboardQCStayPatientFence = this.msToTime(duration11);

      let duration12 = Math.round(data.hospitalWaitingDurationAvg.valueDouble);
      duration12 = duration12 * 1000;
      this.dashboardQCStayHospital = this.msToTime(duration12);

      let duration13 = Math.round(data.hospitalWaitingDurationFenceAvg.valueDouble);
      duration13 = duration13 * 1000;
      this.dashboardQCStayHospitalFence = this.msToTime(duration13);

      let duration14 = Math.round(data.callTillFinishDurationAvg.valueDouble);
      duration14 = duration14 * 1000;
      this.dashboardQCCallToFinish = this.msToTime(duration14);

      let duration15 = Math.round(data.callTillFinishDurationFenceAvg.valueDouble);
      duration15 = duration15 * 1000;
      this.dashboardQCCallToFinishFence = this.msToTime(duration15);
      //rows 4
      if (data.missionsByDate.length > 0) {
        let lineData = [];
        for (let i = 0; i < data.missionsByDate.length; i++) {
          let date2 = new Date(data.missionsByDate[i].title.toString());
          let date3 = date2.toString();
          let splitForTime = date3.split(' ');
          let time = splitForTime[4];
          let splitedTime = time.split(':');
          let today = new Date(date2).toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            formatMatcher: 'basic',
          });
          let sp = today.split('/');
          lineData.push([
            Date.UTC(sp[2], sp[0] - 1, sp[1], splitedTime[0], splitedTime[1], 0),
            data.missionsByDate[i].valueLong,
          ]);
        }
        this.dashboardQCLineMissionChartOptions.series[0].data = lineData;
      }
    },
    initialFilter: function () {
      const date = new Date()?.toISOString()?.split('Z')[0];
      this.filterFields.fromDate = date?.split('T')[0] + 'T00:00:00';
      this.filterFields.toDate = null;
    },
    setFilter: function (fromDate, toDate) {
      this.filterFields.fromDate = fromDate;
      this.filterFields.toDate = toDate;
      this.getQCDashboardFunction(this.filterFields);
      this.closeFilterModal();
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
  },
};
